import { useEffect } from "react";
import { usePostPropertyFlatMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPropertyFlatMutation";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { BuildingCreateFormFields } from "web_myplann/Portfolio/Forms/BuildingShared/BuildingCreateFormFields";
import { FLAT_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/FlatForm/flatFormDefaults";
import {
	type FlatFormInput,
	getFlatFormSchema,
} from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";
import type { RealEstateType } from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";
import { PortfolioFormShell } from "web_myplann/Portfolio/PortfolioShared/PortfolioFormShell";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

type CreateFlatFormProps = {
	onTypeChange: (type: RealEstateType) => void;
	registerSnapshot: (getValues: () => FlatFormInput) => void;
	initialValues: FlatFormInput | undefined;
};

export const CreateFlatForm = ({
	onTypeChange,
	registerSnapshot,
	initialValues,
}: CreateFlatFormProps) => {
	const { t } = useResource();

	const { mutate, isPending } = usePostPropertyFlatMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getFlatFormSchema(t),
		defaultValues: initialValues ?? FLAT_FORM_DEFAULT_VALUES,
		mutate: ({ landSize, ...values }, options) => mutate(values, options),
		successRoute: Routing.Portfolio.PortfolioAddRealEstateSuccess.path(),
	});

	useEffect(() => {
		registerSnapshot(form.getValues);
	}, [registerSnapshot, form.getValues]);

	return (
		<PortfolioFormShell
			onSubmit={onSubmit}
			submitLabel={t(Resources.Portfolio.AddRealEstate.submit)}
			disabled={!form.formState.isDirty}
			loading={isPending}
		>
			<BuildingCreateFormFields
				control={form.control}
				type={ClientPropertyTypeEnum.Flat}
				onTypeChange={onTypeChange}
			/>
		</PortfolioFormShell>
	);
};
